// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"473":"cd7be49019ea1be5","888":"e5b83cb8aa9a9caf"}[chunkId] + ".css";
};